(() => {
  function init() {
    document.querySelectorAll('.ezdb-guide[data-guide]').forEach(root => {
      if (root.dataset.flowReady) return;
      const chooser = root.querySelector('.ezdb-select-wrap');
      const panels = Array.from(root.querySelectorAll('.ezdb-panel'));
      if (!chooser || !panels.length || chooser.parentElement !== root) return;
      root.dataset.flowReady = 'true';
      const background = document.createElement('details');
      background.className = 'ezdb-help ezdb-guide-background';
      const summary = document.createElement('summary');
      summary.textContent = root.dataset.guide === 'pull-measurements' ? 'Read the rules that apply to every measurement' : 'Planning help: music analysis and subwoofer specifications';
      background.append(summary);
      Array.from(root.childNodes).forEach(node => {
        if (node === chooser || panels.includes(node) || (node.nodeType === 1 && /^(SCRIPT|STYLE)$/.test(node.tagName))) return;
        background.append(node);
      });
      const intro = document.createElement('p');
      intro.textContent = 'Choose your build type to see its instructions. Review the planning guidance below before submitting your order.';
      root.prepend(intro, chooser, ...panels);
      root.append(background);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
